<template lang="pug">
    include ../../../media/pug/mixins.pug
    +b.SECTION.modal-content
        template(v-if="!isMobile")
            +e.P.text(
                v-for="(text, index) in text"
                v-bind:key="index"
                v-html="text"
            )
        +e.UL.list
            template(v-if="!isMobile")
                +e.LI.item(
                    v-for="item in commands"
                    v-bind:key="item.command"
                )
                    +e.P.command {{item.command}}
                    +e.P.description {{item.description}}
            template(v-else)
                +e.LI.item(
                    v-for="item in mobileCommands"
                    v-bind:key="item.icon"
                )
                    +e.command
                        +e.V-ICON.icon(
                            v-bind:class=
                            "[item.iconClass ? `modal-content__icon_${item.iconClass}` : '']"
                            v-bind:name="item.icon"
                        )
                    +e.P.description {{item.description}}
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            text: [
                `Для осуществления <b>навигации</b> по страницам используйте кнопки, находящиеся на верхней панели.
                 Для <b>масштабирования</b> страницы можно использовать ползунок справа (trackbar).',
                'Для <b>загрузки документа на компьютер</b> используйте кнопку, находящуюся справа на верхней панели.
                `,
                `При загрузке страницы сверху будет появляться линия прогресса загрузки.
                 На <b>боковой панели</b> показываются уменьшенные страницы документа.
                 Вы можете переходить на нужную страницу просто кликнув на ее уменьшенную копию.
                `,
                `Масштаб миниатюр на боковой нанели можно изменять, используя ползунок над ней.
                 Размер боковой панели можно изменять, потянув ее за правую сторону.`,
                `Чтобы <b>скрыть боковую панель</b> нажмите на кнопку рядом с ней,
                чтобы вернуть панель кликните по кнопке еще раз.`,
                'Для просмотра документа также можно использовать <b>горячие клавиши:</b>'
            ],
            commands: [
                {
                    command: `ctrl+${this.$t('RIGHT')}`,
                    description: this.$t('NEXT_PAGE')
                },
                {
                    command: `ctrl+${this.$t('LEFT')}`,
                    description: this.$t('PREVIOUS_PAGE')
                },
                {
                    command: `shift+${this.$t('UP')}`,
                    description: this.$t('ZOOM_IN')
                },
                {
                    command: `shift+${this.$t('DOWN')}`,
                    description: this.$t('ZOOM_OUT')
                },
                {
                    command: 'shift+f',
                    description: this.$t('GO_TO_MAIN_PAGE')
                },
                {
                    command: 'shift+l',
                    description: this.$t('GO_TO_PREVIOUS_PAGE')
                },
                {
                    command: 'shift+p',
                    description: this.$t('HIDE_PANEL_WITH_PREVIEW_PAGES')
                },
                {
                    command: 'shift+w',
                    description: this.$t('FIT_PAGE_BY_WIDTH')
                },
                {
                    command: 'shift+h',
                    description: this.$t('FIT_PAGE_BY_HEIGHT')
                },
                {
                    command: 'page up, page down, home, end',
                    description: this.$t('SCROLL_CURRENT_PAGE')
                }
            ],
            mobileCommands: [
                {
                    icon: '#finger_click',
                    description: this.$t('SHOW_HIDE_NAVIGATION_PANEL')
                },
                {
                    icon: '#finger_left',
                    description: this.$t('GO_TO_NEXT_PAGE')
                },
                {
                    icon: '#finger_right',
                    description: this.$t('GO_TO_PREVIOUS_PAGE')
                },
                {
                    icon: '#zoom',
                    description: this.$t('PAGE_SCALING')
                },
                {
                    icon: '#menu',
                    iconClass: 'menu',
                    description: this.$t('MENU_DESCRIPTION')
                }
            ]
        };
    },
    computed: {
        ...mapGetters([
            'isMobile'
        ])
    }
};
</script>
